import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Card } from 'react-bootstrap';

import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

import SolutionSidebar from '../elements/services/solution-sidebar';

import Banner1 from '../../images/banner/banner1.jpg';
import ServicesPic1 from '../../images/services/service_5.jpg';
import ServicesPic2 from '../../images/services/pic2.jpg';

class SolutionProductionOptimization extends Component {

    render() {
        return (
            <>
                <Header1 />

                <div className="page-content bg-white">

                    <div className="page-banner ovbl-dark parallax" style={{ backgroundImage: "url(" + Banner1 + ")" }}>
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">Production Optimization (AI & Nanotechnology)</h1>
                                <div className="breadcrumb-row">
                                    <ul className="list-inline">
                                        <li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
                                        <li>Production Optimization</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-block" id="content-area">

                        <div className="section-area section-sp2 bg-white">
                            <div className="container about-video">
                                <div className="row">

                                    <div className="col-lg-4 col-md-5 m-b30">
                                         <SolutionSidebar activeService={5} />
                                    </div>

                                    <div className="col-lg-8 col-md-7 service-textarea">

                                        <div className="heading-bx text-left m-b20">
                                            <h3 className="title-head m-b0">Production Optimization</h3>
                                            <div className="ttr-separator sepimg"></div>
                                        </div>

                                        <p>
                                            We enhance oil and gas production through AI, advanced analytics, 
                                            and nanotechnology solutions that increase flow efficiency, reduce 
                                            downtime, and extend asset life.
                                        </p>

                                        <div className="row m-b30">
                                            <div className="col-md-12">
                                                <img src={ServicesPic1} className="radius-sm imghight" alt="" />
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Our Solutions</h4>
                                        <p>
                                            Intelligent optimization tools allow operators to improve recovery 
                                            rates and reduce operational costs.
                                        </p>

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>AI-driven production forecasting</li>
                                                    <li>Nano-enhanced flow improvement</li>
                                                    <li>CO₂ & N₂ injection optimization</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Artificial lift optimization</li>
                                                    <li>Real-time production analytics</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Benefits</h4>
                                        <p>Maximize production efficiency while reducing cost and energy consumption.</p>

                                        <div className="row">
                                            <div className="col-xl-7 col-lg-12">
                                                <ul className="service-list-circle">
                                                    <li><i className="flaticon-maintenance"></i>Higher hydrocarbon recovery</li>
                                                    <li><i className="flaticon-light-bolt"></i>Reduced operating costs</li>
                                                    <li><i className="flaticon-mask"></i>Extended equipment lifetime</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <Accordion className="ttr-accordion gray" defaultActiveKey="0">

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                                    <Link to="#">Artificial Lift Systems</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="0">
                                                    <Card.Body>
                                                        Optimized ESP, PCP, and gas lift systems using predictive algorithms.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="1">
                                                    <Link to="#">Nano-Technology Agents</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body>
                                                        Improve reservoir permeability using advanced nano-fluids.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                        </Accordion>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <Footer1 />

            </>
        );
    }
}

export default SolutionProductionOptimization;
